import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2"; // Import SweetAlert2
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl"; // Assuming BASE_URL is exported from your Baseurl.js

const OrgQuery = ({ eventid }) => {
  // State to store form data
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    company: "",
    message: "",
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Add eventid to the form data
    const dataToSend = { ...formData, eventid };

    // Send form data to backend API using axios
    try {
      const response = await axios.post(`${BASE_URL}orgquery`, dataToSend, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        // Show SweetAlert2 success message
        Swal.fire({
          title: 'Success!',
          text: 'You will receive a reply on mail from organizer',
          icon: 'success',
          confirmButtonText: 'Okay',
        }).then(() => {
          // Reload the page after successful submission
          window.location.reload(); // This will reload the page
        });
      } else {
        console.log("Failed to submit form:", response.statusText);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }

    // Optionally reset the form after submission
    setFormData({
      name: "",
      email: "",
      mobile: "",
      company: "",
      message: "",
    });
  };


  return (
    <>

    <div>
    Queries about the event?
    <span
        className="btnnflow1 mx-1"
        data-bs-toggle="modal"
        data-bs-target="#orgquery"
      >
         Ask Organizer
      </span>
    </div>
      

      <div
        className="modal fade"
        id="orgquery"
        tabIndex="-1"
        aria-labelledby="orgqueryLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content p-0">
            <div className="modal-header">
              <h5 className="modal-title" id="orgqueryLabel">
              For any inquiries about the event, please contact the organizer.
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-2">
                  <div className="col-md-12">
                    <label htmlFor="name" className="form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="input-class"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter Name Here"
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <label htmlFor="email" className="form-label">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="input-class"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter Email Here"
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <label htmlFor="mobile" className="form-label">
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <input
  type="text"
  className="input-class"
  id="mobile"
  name="mobile"
  value={formData.mobile}
  onChange={(e) => {
    const input = e.target.value;
    if (/^\d{0,10}$/.test(input)) {
      handleInputChange(e); // only allow up to 10 digits
    }
  }}
  placeholder="Enter Mobile Number Here"
  required
/>

                  </div>

                  <div className="col-md-12">
                    <label htmlFor="company" className="form-label">
                      Company Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="input-class"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      placeholder="Enter Company Name Here"
                    />
                  </div>

                  <div className="col-md-12">
  <label htmlFor="message" className="form-label">
    Message <span className="text-danger">*</span>
  </label>
  <textarea
    className="textarea-class"
    id="message"
    name="message"
    maxLength={255}
    value={formData.message}
    onChange={handleInputChange}
    rows="4"
    placeholder="Enter Message Here"
    required
  ></textarea>
  <div className="text-end mt-1">
    {formData.message.length}/255 characters
  </div>
</div>

                </div>

    <div className="text-end">
    <button type="submit" className="btnsubmit mt-3">
                  Send Query
                </button>
    </div>
                
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrgQuery;
